export const CHART_NAME = "Chart";
export const chartClasses = {
  highlighted: `${CHART_NAME}-highlighted`,
  dimmed: `${CHART_NAME}-dimmed`,
};
